import React from 'react';
import PriceTicker from '../../components/PriceTicker.jsx';
import { Link } from 'react-router-dom';
import { useI18n, usePageTitle } from '../../i18n/index.jsx';
import { useAuth } from '../../auth.jsx';
import Icon from '../../components/Icon.jsx';
// The animated ship map (components/heroScene) is kept but not used; to
// bring it back, render <HeroScene /> in .hero-art and add `hero-has-scene`
// to the section.
import HeroVideo from '../../components/HeroVideo.jsx';
import SectorShowcase from '../../components/sectors/SectorShowcase.jsx';
import LatestNews from '../../components/LatestNews.jsx';
import LatestRequests from '../requests/LatestRequests.jsx';
import { useContent } from '../../content.jsx';

const STEP_ICONS = ['user', 'upload', 'mail'];
const WHY_ICONS = ['check', 'lock', 'globe', 'pin'];

export default function Home() {
  const { t, tm } = useI18n();
  const { user } = useAuth();
  const { text, value } = useContent('home');
  usePageTitle(null);

  return (
    <>
      <PriceTicker />
      <section className="hero">
        <div className="hero-art">
          <HeroVideo video={value('heroVideo', '/hero.mp4')} poster={value('heroPoster', '/hero-poster.jpg')} />
          <div className="hero-overlay" />
        </div>
        <div className="container hero-inner">
          <div className="hero-copy">
            <p className="eyebrow">{text('eyebrow', 'home.eyebrow')}</p>
            <h1>{text('title', 'home.title')}</h1>
            <p className="hero-lead">{text('lead', 'home.lead')}</p>
            <div className="hero-actions">
              <Link className="btn btn-primary btn-lg" to="/marketplace">{text('ctaBrowse', 'home.ctaBrowse')}</Link>
              {!user && <Link className="btn btn-light btn-lg" to="/signup">{text('ctaJoin', 'home.ctaJoin')}</Link>}
            </div>
          </div>
        </div>
      </section>

      <SectorShowcase />

      <LatestRequests />

      {value('showNews', true) && <LatestNews />}

      <section className="section section-alt">
        <div className="container">
          <header className="section-head">
            <h2>{t('home.howTitle')}</h2>
            <p className="muted">{t('home.howLead')}</p>
          </header>
          <ol className="steps">
            {tm('home.steps').map((s, i) => (
              <li className="step" key={s.t}>
                <span className="step-num">{i + 1}</span>
                <span className="tile-icon"><Icon name={STEP_ICONS[i]} /></span>
                <h3>{s.t}</h3>
                <p className="muted">{s.d}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <header className="section-head">
            <h2>{t('home.whyTitle')}</h2>
          </header>
          <div className="feature-grid">
            {tm('home.why').map((w, i) => (
              <div className="feature" key={w.t}>
                <span className="feature-icon"><Icon name={WHY_ICONS[i]} size={22} /></span>
                <div>
                  <h3>{w.t}</h3>
                  <p className="muted">{w.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand title={t('home.ctaTitle')} text={t('home.ctaText')}>
        {!user && <Link className="btn btn-primary btn-lg" to="/signup">{t('home.ctaJoin')}</Link>}
        <Link className="btn btn-light btn-lg" to="/contact">{t('home.ctaContact')}</Link>
      </CtaBand>
    </>
  );
}

export function CtaBand({ title, text, children }) {
  return (
    <section className="cta-band">
      <div className="container cta-inner">
        <div>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <div className="cta-actions">{children}</div>
      </div>
    </section>
  );
}
